// Emily Burns · Real data supplied by the player & official scouting report
// All values verified (Wyscout / official scouting report · 2025/26).

export const playerInfo = {
  firstName: "Emily",
  lastName: "Burns",
  fullName: "Emily Rachael Burns",
  position: "Goalkeeper",
  nationality: "Canada",
  nationalityCode: "CA",
  dateOfBirth: "1997-07-24",
  age: 28,
  height: "175 cm",
  preferredFoot: "Right",
  currentClub: "Olympique de Marseille",
  currentLeague: "Arkema Première Ligue",
  squadNumber: 1,
  contractUntil: "June 2026",
  nationalTeam: "Canada W · Copa SheBelieves",
  instagram: "buurnsie",
  instagramUrl: "https://instagram.com/buurnsie"
};

// Real photos of Emily (customer asset CDN)
const P = (slug, name) =>
  `https://customer-assets.emergentagent.com/job_goalkeep-emily/artifacts/${slug}_${name}.jpeg`;

export const photos = {
  hero: "https://customer-assets-eiarnc6j.emergentagent.net/job_goalkeep-emily/artifacts/fa6d9f99663d1f2d_marseille_2.jpg",
  videoFeaturedThumb: P("7aorne5k", "IMG_6566"),
  videoShortThumb: P("3im7i5gq", "IMG_4269"),
  gallery: [
    { src: P("7aorne5k", "IMG_6566"), alt: "1v1 save vs PSG attacker", tag: "Match" },
    { src: P("3im7i5gq", "IMG_4269"), alt: "On one knee during match", tag: "Match" },
    { src: P("re4z02vo", "IMG_4287"), alt: "Walking across the box · Beaujoire", tag: "Match" },
    { src: P("vd9raso0", "IMG_4285"), alt: "Alone on the pitch · Beaujoire", tag: "Match" },
    { src: P("jqm7b6zz", "IMG_4289"), alt: "Goal-line stance", tag: "Match" },
    { src: P("mh9mlqmn", "IMG_4276"), alt: "Playing the ball out", tag: "Match" },
    { src: P("z9rxx3ho", "IMG_6581"), alt: "Match footage", tag: "Match" },
    { src: P("x2o5ufas", "IMG_6571"), alt: "Standing alert · Stade de la Beaujoire", tag: "Match" },
    { src: P("14pq0tdb", "IMG_6580"), alt: "Match footage", tag: "Match" },
    { src: P("ek11eyhk", "IMG_6579"), alt: "Match footage", tag: "Match" },
    { src: P("14ytt4p6", "IMG_6578"), alt: "Match footage", tag: "Match" },
    { src: P("vlw7dhpv", "IMG_6577"), alt: "Match footage", tag: "Match" },
    { src: P("mdcmhvgd", "IMG_6576"), alt: "Match footage", tag: "Match" },
    { src: P("sfoaz1yz", "IMG_6575"), alt: "Pre-match warm up", tag: "Training" },
    { src: P("as7voubg", "IMG_6574"), alt: "Canada national team training", tag: "International" },
    { src: P("g0mhb3rr", "IMG_6573"), alt: "FC Nantes portrait", tag: "Portrait" },
    { src: P("37dey9np", "IMG_6572"), alt: "Team arrival", tag: "Behind the scenes" },
    { src: P("90nthi5b", "IMG_6570"), alt: "Match · Beaujoire atmosphere", tag: "Match" },
    { src: P("gxfwpfy2", "IMG_6569"), alt: "Match · Beaujoire", tag: "Match" },
    { src: P("6rh7pnpb", "IMG_6568"), alt: "Behind the goal net", tag: "Portrait" }
  ]
};

export const videos = {
  featured: {
    provider: "vimeo",
    videoId: "1162842447",
    hash: "82415f1956"
  },
  clips: [
    {
      id: "short",
      provider: "vimeo",
      videoId: "1181058315",
      hash: "d643cccf69"
    }
  ]
};

// Real stats from the official Wyscout-based scouting report (2025/26)
export const stats = {
  primary: [
    { key: "matches", value: 19, suffix: "" },
    { key: "minutes", value: "1,878", suffix: "" },
    { key: "saves", value: 74, suffix: "%" },
    { key: "aerials", value: 72, suffix: "%" }
  ],
  secondary: [
    { key: "reflex", value: "66%" },
    { key: "passAcc", value: "89%" },
    { key: "longPass", value: "56%" },
    { key: "gPrevented", value: "0.24" },
    { key: "totalActions", value: "78%" },
    { key: "cleanSheets", value: "4" }
  ],
  rankings: [
    { league: "English First Division (FAWSL)", score: 54.9, rank: "10/24" },
    { league: "Spanish First Division (Liga F)", score: 53.8, rank: "5/35" },
    { league: "US First Division (NWSL)", score: 48.4, rank: "8/22" },
    { league: "Top 20 Goalkeepers Worldwide", score: 43.3, rank: "17/21" }
  ]
};

// Real career data from the official scouting report
export const career = [
  {
    year: "2026/27",
    club: "Olympique de Marseille",
    country: "France",
    league: "Arkema Première Ligue · D1",
    matches: "—",
    role: "Signed 14/07/2026 · First-choice goalkeeper · #1"
  },
  {
    year: "2025/26",
    club: "FC Nantes",
    country: "France",
    league: "Arkema Première Ligue · D1",
    matches: 20,
    role: "Finalist · Best Goalkeeper · Première Ligue"
  },
  {
    year: "2024/25",
    club: "FC Nantes",
    country: "France",
    league: "Arkema Première Ligue · D1",
    matches: 23,
    role: "First-choice goalkeeper"
  },
  {
    year: "2023/24",
    club: "FC Nantes",
    country: "France",
    league: "Seconde Ligue · D2",
    matches: 23,
    role: "Best Goalkeeper of the Season"
  },
  {
    year: "2022/23",
    club: "Dijon FCO",
    country: "France",
    league: "Arkema Première Ligue · D1",
    matches: 1,
    role: "Senior goalkeeper"
  },
  {
    year: "2021/22",
    club: "AS Saint-Étienne",
    country: "France",
    league: "Seconde Ligue · D2",
    matches: 10,
    role: "Senior goalkeeper"
  },
  {
    year: "2020/21",
    club: "Racing Santander",
    country: "Spain",
    league: "Reto Iberdrola",
    matches: 0,
    role: "Squad goalkeeper"
  },
  {
    year: "2020",
    club: "Calgary Foothills",
    country: "Canada",
    league: "United Women's Soccer",
    matches: 0,
    role: "Squad goalkeeper"
  }
];

// Real achievements (from the official scouting report)
export const achievements = {
  en: [
    {
      year: "2026",
      title: "Signed by Olympique de Marseille",
      subtitle: "Les Marseillaises · First-choice goalkeeper · #1 · from 14 July 2026"
    },
    {
      year: "2025/26",
      title: "Finalist · Best Goalkeeper · Première Ligue",
      subtitle: "French First Division · Arkema Première Ligue"
    },
    {
      year: "2023 — 2026",
      title: "67 of 67 league matches at FC Nantes",
      subtitle: "Three seasons · Full availability"
    },
    { year: "2025/26", title: "Most saves in the league", subtitle: "Arkema Première Ligue · France" },
    {
      year: "2025/26",
      title: "11 decisive late-match saves",
      subtitle: "Contributing 38 points to FC Nantes during the season"
    },
    {
      year: "2024/25",
      title: "Nominated · Top 5 Goalkeepers",
      subtitle: "French First Division · Arkema Première Ligue"
    },
    {
      year: "2023/24",
      title: "Best Goalkeeper of the Season",
      subtitle: "French Second Division · Seconde Ligue"
    },
    {
      year: "—",
      title: "International call-ups · Canada W",
      subtitle: "Copa SheBelieves"
    }
  ],
  fr: [
    {
      year: "2026",
      title: "Signée à l'Olympique de Marseille",
      subtitle: "Les Marseillaises · Gardienne titulaire · #1 · à partir du 14 juillet 2026"
    },
    {
      year: "2025/26",
      title: "Finaliste · Meilleure gardienne · Première Ligue",
      subtitle: "Première Division française · Arkema Première Ligue"
    },
    {
      year: "2023 — 2026",
      title: "67 matchs sur 67 au FC Nantes",
      subtitle: "Trois saisons · Disponibilité totale"
    },
    { year: "2025/26", title: "Gardienne avec le plus d'arrêts de la ligue", subtitle: "Arkema Première Ligue · France" },
    {
      year: "2025/26",
      title: "11 arrêts décisifs en fin de match",
      subtitle: "Contribution de 38 points au FC Nantes sur la saison"
    },
    {
      year: "2024/25",
      title: "Nominée · Top 5 Gardiennes",
      subtitle: "Première Division française · Arkema Première Ligue"
    },
    {
      year: "2023/24",
      title: "Meilleure gardienne de la saison",
      subtitle: "Deuxième Division française · Seconde Ligue"
    },
    {
      year: "—",
      title: "Sélections internationales · Canada F",
      subtitle: "Copa SheBelieves"
    }
  ],
  es: [
    {
      year: "2026",
      title: "Fichaje por el Olympique de Marseille",
      subtitle: "Les Marseillaises · Portera titular · #1 · desde el 14 de julio de 2026"
    },
    {
      year: "2025/26",
      title: "Finalista · Mejor portera · Première Ligue",
      subtitle: "Primera División francesa · Arkema Première Ligue"
    },
    {
      year: "2023 — 2026",
      title: "67 de 67 partidos de liga en el FC Nantes",
      subtitle: "Tres temporadas · Disponibilidad total"
    },
    { year: "2025/26", title: "Portera con más paradas de la liga", subtitle: "Arkema Première Ligue · Francia" },
    {
      year: "2025/26",
      title: "11 paradas decisivas en el tramo final",
      subtitle: "Aportó 38 puntos al FC Nantes durante la temporada"
    },
    {
      year: "2024/25",
      title: "Nominada · Top 5 Porteras",
      subtitle: "Primera División francesa · Arkema Première Ligue"
    },
    {
      year: "2023/24",
      title: "Mejor portera de la temporada",
      subtitle: "Segunda División francesa · Seconde Ligue"
    },
    {
      year: "—",
      title: "Convocatorias internacionales · Canadá F",
      subtitle: "Copa SheBelieves"
    }
  ]
};

export const contactInfo = {
  agent: "Solo Cracks",
  representative: "Edgar Merino · FIFA Licensed Agent",
  email: "merinovidangossy@gmail.com",
  phone: "+34 665 497 561",
  whatsapp: "34665497561",
  location: "Barcelona, Spain",
  instagramUrl: "https://instagram.com/buurnsie",
  instagramHandle: "@buurnsie"
};

export const agencyInfo = {
  name: "Solo Cracks",
  tagline: "Football Agency · FIFA",
  logo:
    "https://customer-assets.emergentagent.com/job_goalkeep-emily/artifacts/yyp9bqav_39fcf3c8-df29-4253-a453-df2e5450e6be.jpeg",
  website: "https://www.solocracks.management",
  websiteLabel: "solocracks.management",
  instagram: "https://instagram.com/solocracks",
  instagramHandle: "@solocracks",
  agent: {
    name: "Edgar Merino",
    title: "FIFA Licensed Agent",
    website: "https://www.edgarmerino.com",
    websiteLabel: "edgarmerino.com",
    instagram: "https://instagram.com/edgarmerino19",
    instagramHandle: "@edgarmerino19"
  }
};

export const dossierUrl =
  `${process.env.REACT_APP_BACKEND_URL}/api/dossier/Emily_Burns_Scouting_Dossier_2025-26.pdf`;
